import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle } from '../../components/icons';

export function DisclaimerPageTR() {
  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/tr/register"
          className="inline-flex items-center gap-2 text-chocolate-600 hover:text-sage-600 mb-8 transition-colors font-medium"
        >
          <ArrowLeft className="w-5 h-5" />
          Kayit Sayfasina Don
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="freud-card-elevated p-8 mb-8"
        >
          <div className="flex items-center gap-4 mb-8">
            <AlertTriangle className="w-12 h-12 text-sand-600" />
            <h1 className="freud-heading-2xl text-chocolate-900">
              Kisilik Gelisim Profili Sorumluluk Reddi ve Tazminat
            </h1>
          </div>

          <div className="prose prose-chocolate max-w-none space-y-6">
            <h2 className="freud-heading-xl text-chocolate-900">Sorumluluk Reddi</h2>
            <p className="freud-text-base text-chocolate-700">
              Bu Kisilik Gelisim Profilinde saglanan bilgiler yalnizca egitim ve kocluk amaclarina yoneliktir. Psikolojik, tibbi, finansal, hukuki veya teshise yonelik tavsiye olarak yorumlanmamalidir. Icgoruler ve oneriler, bireyin verdigi yanitlardan ve kocluk envanter aracinin metodolojisinden turetilmistir.
            </p>
            <p className="freud-text-base text-chocolate-700">
              Bu profil psikolojik veya tibbi bir test degildir ve sonuclar herhangi bir ruh sagligi durumunu veya diger psikolojik ya da fiziksel sorunlari teshis etmez, tedavi etmez veya ongormez. Kullanicilar bu tur endiseleri icin uygun profesyonel tavsiye almaya tesvik edilir.
            </p>
            <p className="freud-text-base text-chocolate-700">
              Kisilik Gelisim Profili, yaraticilari, bagli kuruluslari ve uygulamacilari, bu profilde yer alan bilgilerin dogrulugunu, eksiksizligini veya uygulanabilirligini garanti etmez. Bu profilin kullanilmasi ve saglanan bilgilere dayali olarak alinan kararlar tamamen alicinin takdirinde ve riskindedir.
            </p>

            <h2 className="freud-heading-xl text-chocolate-900 mt-12">Kullanim Sinirlamalari</h2>
            <p className="freud-text-base text-chocolate-700">
              Bu profil araci ve sonuclari, profesyonel tavsiye, terapi veya teshis hizmetlerinin yerine gecmez. Bulgular istihdam, kisisel iliskiler, saglik veya refah ile ilgili onemli kararlarin alinmasinda tek temel olarak kullanilmamalidir. Kullanicilarin profil sonuclarina dayanarak karar vermeden once nitelikli profesyonellere danismalari siddetle tavsiye edilir.
            </p>

            <h2 className="freud-heading-xl text-chocolate-900 mt-12">Sorumluluk</h2>
            <p className="freud-text-base text-chocolate-700">
              Kisilik Gelisim Profili, yaraticilari, bagli kuruluslari, calisanlari ve ilgili uygulamacilari, bu profilin veya profil sonuclarinin kullanimindan veya bunlarla baglantili olarak ortaya cikan herhangi bir dogrudan, dolayli, arizi, ozel, sonuc olarak ortaya cikan veya diger zararlar icin acikca her turlu sorumlulucu reddeder.
            </p>
            <p className="freud-text-base text-chocolate-700">
              Bu profili kullanarak, alici; Kisilik Gelisim Profilini, yaraticilerini, bagli kuruluslarini, calisanlarini, uygulamacilerini ve ilgili taraflari, profilin veya sonuclarinin kullanimindan veya kotuye kullanimindan kaynaklanan her turlu talep, sorumluluk, kayip, zarar veya masrafa (hukuki ucretler dahil) karsi tazmin etmeyi, savunmayi ve zararsiz tutmayi kabul eder.
            </p>

            <h2 className="freud-heading-xl text-chocolate-900 mt-12">Gizlilik</h2>
            <p className="freud-text-base text-chocolate-700">
              Kisilik Gelisim Profili, tum bireylerin gizliligini ve mahremiyetini korumaya kararlıdır. Profil sureci sirasinda toplanan kisisel veriler, Genel Veri Koruma Yonetmeligi (GDPR) ve diger yururlukteki gizlilik yasalari dahil olmak uzere ilgili veri koruma duzenlemelerine uygun gizlilik politikamiza gore islenir.
            </p>
            <p className="freud-text-base text-chocolate-700">
              Toplanan tum veriler yalnizca bu profili olusturmak ve ilgili hizmetleri sunmak amaciyla kullanilacaktir. Yasa geregi zorunlu olmadikca, acik onay alinmadan hicbir kisisel veri ucuncu taraflarla paylasilmayacak, satilmayacak veya ifsa edilmeyecektir.
            </p>

            <h2 className="freud-heading-xl text-chocolate-900 mt-12">Kabul</h2>
            <p className="freud-text-base text-chocolate-700">
              Bu profili kullanarak, alici bu Sorumluluk Reddi ve Tazminat kosullarini kabul ettigini beyan eder. Bu kosullari kabul etmiyorsaniz, lutfen bu profili veya ilgili hizmetleri kullanmaktan kacinin. Bu profilin devamli kullanimi bu kosullarin tamamen kabul edildigi anlamina gelir.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
